import { render, staticRenderFns } from "./js.vue?vue&type=template&id=38be79df&"
import script from "./js.vue?vue&type=script&lang=js&"
export * from "./js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports